import Button from './button';

export default (props) => {
    const { children } = props;

    return <Button { ...props } className="button--history" icon='history'>{ children ? children : 'History' }</Button>
}